import { getExpense } from "../../backend-services";
import React from "react";
import { ExpenseCategory, ICreateExpenseData } from "../../@types";
import { Annotation } from "../../@types/annotation";
import { useNavigate } from "react-router-dom";
export const useExpense = (expenseId: string) => {
  const [expense, setExpense] = React.useState<ICreateExpenseData>({
    billedTo: "",
    companyId: "",
    description: "",
    id: "",
    customerId: "",
    //  type: 'non-billable',
    category: "" as ExpenseCategory,
    currency: "",
    date: "",
    lineItems: [],
    notes: "",
    vendorName: "",
    additionalInformation: "",
    amount: 0,
    paymentMethod: "",
    reference: "",
    createdAt: 0,
    isBillable: false,
    isProtected: false,
    exchangeRate: 0,
    name: "",
  });
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);
  const [annotations, setAnnotations] = React.useState<Annotation[]>([]);

  const fetchExpense = async () => {
    setIsLoading(true);
    try {
      const expense = await getExpense(expenseId);
      setExpense(expense);
      if (expense?.metadata) setAnnotations(expense?.metadata?.annotations);
    } catch (error: any) {
      if (error.message == "expense not found") {
        navigate("/expenses"); // Go back
      }
    } finally {
      setIsLoading(false);
    }
  };
  React.useEffect(() => {
    fetchExpense();
  }, [expenseId]);

  return { expense, isLoading, annotations, fetchExpense };
};
